import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FaRegSadTear} from "react-icons/fa";

const Search = ({ searchData, setSearchResults }) => {
  const [value, setValue] = useState("");

  const onChange = (event) => {
    setValue(event.target.value);
  };

  const onSearch = () => {
    setSearchResults(filterItems(value.toLowerCase()));
  };

  // Function to filter items based on the search term
  const filterItems = (searchTerm) => {
    if (searchTerm === "") {
      return searchData; // Return the original data when search term is empty
    }

    return searchData.filter((item) => {
      const productName = item.product_name.toLowerCase();
      return productName.includes(searchTerm);
    });
  };
  
// useEffect hook to update search results when value or searchData changes
  useEffect(() => {
    setSearchResults(filterItems(value.toLowerCase()));
  }, [value, searchData]);

  return (
    <section>
      <div className="flex justify-center md:justify-normal">
        <input
          type="text"
          value={value}
          placeholder="Search items..."
          className="py-1 mt-2 md:ml-auto  mr-2 px-4 w-64 md:w-96 rounded-md border-2 border-gray-400 focus:outline-none focus:border-blue-500"
          onChange={onChange}
        />
        <div className="flex items-center">
          <button
            type="submit"
            onClick={onSearch}
            className="bg-blue-500 text-white py-1 mt-2 px-4 rounded-md hover:bg-blue-600"
          >
            Search
          </button>
        </div>
      </div>
    </section>
  );
};

export default Search;
